import { render, staticRenderFns } from "./PrintBillMultiple.vue?vue&type=template&id=087c2f7f&scoped=true"
import script from "./PrintBillMultiple.vue?vue&type=script&lang=js"
export * from "./PrintBillMultiple.vue?vue&type=script&lang=js"
import style0 from "./PrintBillMultiple.vue?vue&type=style&index=0&id=087c2f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c2f7f",
  null
  
)

export default component.exports